const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentConfirmButton.tsx';
import { Button } from '@mui/material';
import * as React from 'react';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { useDispatch } from 'react-redux';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { Chip } from 'App/components/Chip/Chip';
import {
    makeSelectIsLoadingAppointmentConfirmation,
    useAppointmentConfirmation,
} from 'App/store/appointmentConfirmation';
import { getIsSurgeryAppointmentDeadlinePassed } from '../../DashboardPage/Components/appointmentCards/utils';
import { confirmAppointment } from 'App/actions/appointmentConfirmation';
import { useMadeSelector } from '@cistec/common_web/utils/store';

type AppointmentConfirmButtonProps = {
    appointment: StructuredAppointment;
    className?: string;
    text?: string;
};

export const AppointmentConfirmButton = (props: AppointmentConfirmButtonProps) => {
    const { appointment } = props;

    const { formatMessage } = useIntl();
    const dispatch = useDispatch<any>();

    const { data: documentReadConfirmation } = useAppointmentConfirmation(appointment.TERMNR);
    const isAppointmentConfirmed = Boolean(documentReadConfirmation);
    const isSavingDocumentReadConfirmation = useMadeSelector(
        () => makeSelectIsLoadingAppointmentConfirmation(appointment.TERMNR),
        [appointment.TERMNR]
    );

    if (!getIsSurgeryAppointmentDeadlinePassed(appointment)) return null;

    const handleButtonClick = () => {
        dispatch(confirmAppointment(appointment));
    };

    return isAppointmentConfirmed ? (
        <Chip color={'success'}>
            <span className="icons8-checkmark" /> {formatMessage(textMap.confirmed)}
        </Chip>
    ) : (
        <Button
            className={cx(props.className)}
            variant={'contained'}
            color={'primary'}
            onClick={handleButtonClick}
            disabled={isSavingDocumentReadConfirmation || isAppointmentConfirmed}
        >
            {formatMessage(textMap.confirmEintritt)}
        </Button>
    );
};
